(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-v"]) return;
  try {
    
  if (document.getElementById('app-footer-form-trigger')) {
    document.getElementById('app-footer-form-trigger').addEventListener(
      'click',
      function(e) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href');
        document.querySelector(targetId).classList.add("visible");
      }
    );
  }
  if (document.querySelector('.footer-block__newsletter .cancel__button')) {
    document.querySelector('.footer-block__newsletter .cancel__button').addEventListener(
      'click',
      function(e) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href');
        document.querySelector(targetId).classList.remove("visible");
      }
    );
  }
  if (document.querySelector('.footer__content-top .footer-block--menu .icon-accordion')) {
    document.querySelectorAll('.footer__content-top .footer-block--menu .icon-accordion').forEach(function(element) {
      element.addEventListener(
        'click',
        function(e) {
          e.target.closest('.footer-block--menu').classList.toggle("visible");
        }
      );
    });
  }

  /*document.querySelector('#newsletter-popup .footer__newsletter').addEventListener(
    'submit',
    function(e) {
      e.preventDefault();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(e.target);
      config.body = formData;

      fetch(e.target.getAttribute('action'), config)
      .then((response) => console.log(response));

      return false;
    }
  );*/

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (document.getElementById('app-footer-form-trigger')) {
    document.getElementById('app-footer-form-trigger').addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = e.target.getAttribute('href');
      document.querySelector(targetId).classList.add('visible');
    });
  }
  if (document.querySelector('.footer-block__newsletter .cancel__button')) {
    document.querySelector('.footer-block__newsletter .cancel__button').addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = e.target.getAttribute('href');
      document.querySelector(targetId).classList.remove('visible');
    });
  }
  if (document.querySelector('.footer__content-top .footer-block--menu .icon-accordion')) {
    document.querySelectorAll('.footer__content-top .footer-block--menu .icon-accordion').forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.target.closest('.footer-block--menu').classList.toggle('visible');
      });
    });
  }

  /*document.querySelector('#newsletter-popup .footer__newsletter').addEventListener(
    'submit',
    function(e) {
      e.preventDefault();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(e.target);
      config.body = formData;

      fetch(e.target.getAttribute('action'), config)
      .then((response) => console.log(response));

      return false;
    }
  );*/

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lola-quotes"] && !Shopify.designMode) return;
  try {
    
if (document.querySelectorAll('.press-quotes .logos img').length) {
  document.querySelectorAll('.press-quotes .logos img').forEach(function(element, index) {
    element.addEventListener(
      'mouseover',
      function(e) {
        document.querySelectorAll('.press-quotes .logos img').forEach(function(imgElement) {
          imgElement.classList.remove('active');
        });

        e.target.classList.add('active');

        if (document.querySelector('.press-quotes .quote:nth-child('+(index+1)+ ')')) {
          document.querySelectorAll('.press-quotes .quote').forEach(function(quoteElement) {
            quoteElement.style.opacity = 0;
            quoteElement.classList.remove('active');
          });
          document.querySelector('.press-quotes .quote:nth-child('+(index+1)+ ')').classList.add('active');
          document.querySelector('.press-quotes .quote:nth-child('+(index+1)+ ')').style.opacity = 1;
        }
      }
    );
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lola-retailors"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelectorAll('.press-retailors .logos img').length) {
    document.querySelectorAll('.press-retailors .logos img').forEach(function (element, index) {
      element.addEventListener('mouseover', function (e) {
        document.querySelectorAll('.press-retailors .logos img').forEach(function (imgElement) {
          imgElement.classList.remove('active');
        });

        e.target.classList.add('active');

        if (document.querySelector('.press-retailors .quote:nth-child(' + (index + 1) + ')')) {
          document.querySelectorAll('.press-retailors .quote').forEach(function (quoteElement) {
            quoteElement.style.opacity = 0;
            quoteElement.classList.remove('active');
          });
          document.querySelector('.press-retailors .quote:nth-child(' + (index + 1) + ')').classList.add('active');
          document.querySelector('.press-retailors .quote:nth-child(' + (index + 1) + ')').style.opacity = 1;
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  function getOffsetTop(el) {
    var rect = el.getBoundingClientRect(),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  document.querySelectorAll('.collection-product-list .filters .filter').forEach(function (filterElement) {
    filterElement.addEventListener('click', function (e) {
      let scrollTargetElement = e.target.closest('.filter').getAttribute('data-target');
      if (scrollTargetElement == 'filters') {
        window.scroll({ top: 0, behavior: 'smooth' });
      } else {
        let offsetTop = getOffsetTop(document.querySelector(`.collection-product-list .${scrollTargetElement}`));
        console.log(offsetTop);
        window.scroll({ top: offsetTop - 230, behavior: 'smooth' });
        /*document.querySelector(`.collection-product-list .${scrollTargetElement}`).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });*/
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
